<table class="transparent table-fixed">
  @if (isJson(device.value)) {
    @for (
      labelValuePair of JSON.parse(device.value!);
      track labelValuePair.label
    ) {
      <tr>
        <th>
          {{
            "devices.detail.valueLabel." + labelValuePair.labelKey | translate
          }}
        </th>
        <td>
          {{ labelValuePair.value ?? "-" }}
          {{
            labelValuePair.valueUnit
              ? (LabelConverter.getDeviceValueUnitLabel(
                  labelValuePair.valueUnit,
                  false
                ) | translate)
              : ""
          }}
        </td>
      </tr>
    }
  } @else if (!device.isActuator) {
    <tr>
      <th>{{ "devices.detail.value" | translate }}</th>
      <td>
        @if (device.value) {
          {{
            device.valueUnit === DeviceValueUnit.PERCENT
              ? (Number(device.value) / 100 | localizedPercent)
              : (device.value | localizedNumber)
          }}
          @if (device.valueUnit) {
            {{
              LabelConverter.getDeviceValueUnitLabel(device.valueUnit!, false)
                | translate
            }}
          }
        } @else {
          -
        }
      </td>
    </tr>
  } @else {
    <tr>
      <th>{{ "devices.detail.actuatorValue" | translate }}</th>
      <td>
        {{
          (isActiveValue(device.value)
            ? "devices.active.label"
            : "devices.inactive.label"
          ) | translate
        }}
        @if (device.pendingState) {
          <br />
          <small>
            {{ "devices.detail.pending" | translate }}:
            @if (
              device.pendingValue !== null && device.pendingValue !== undefined
            ) {
              {{
                (isActiveValue(device.pendingValue)
                  ? "devices.active.short"
                  : "devices.inactive.short"
                ) | translate
              }}
            }
            @if (device.pendingState != DevicePendingActionState.SENT) {
              ·
              {{ getPendingStateLabelKey(device.pendingState) | translate }}
            }
            @if (
              device.pendingAttemptCount !== null &&
              device.pendingAttemptCount !== undefined &&
              device.pendingAttemptCount > 1
            ) {
              · {{ "devices.detail.pendingAttemptCount" | translate }}
              {{ device.pendingAttemptCount }}
            }
          </small>
        }
      </td>
    </tr>
  }

  <tr>
    <th>{{ "devices.detail.lastSeen" | translate }}</th>
    <td>{{ device.lastSeenDate | relativeDate }}</td>
  </tr>

  @if (device.powerSource) {
    <tr>
      <th>{{ "devices.detail.power" | translate }}</th>
      <td>
        <app-power-item
          [powerSource]="device.powerSource"
          [batteryLevel]="device.batteryLevel"
        />
      </td>
    </tr>
  }

  <ng-content />

  <tr>
    <th>{{ "devices.detail.deviceInfo" | translate }}</th>
    <td>
      {{ device.manufacturer ?? "-" }}
      @if (device.model) {
        ({{ device.model }})
      }
    </td>
  </tr>
</table>
